import { AuthLogin } from "./AuthLogin";
import { AuthTwoFactor } from "./AuthTwoFactor";
import { ForcePasswordChange } from "./ForcePasswordChange";
import { RegisterView } from "./RegisterView";
import { ForgotPassword } from "./ForgotPassword";
import { RestorePassword } from "./RestorePassword";
import { InvitePage } from "./InvitePage";
import { INVITE_ROUTE, RESTORE_ROUTE, S_AUTH_CHANGE_VIEW, S_REGISTRATION_COMPLETE } from "./AuthSignals";

export const AuthView = () => {
	const state = S_AUTH_CHANGE_VIEW.use([]);
	const onRegistrationSuccess = S_REGISTRATION_COMPLETE.use([]);
	let content = null;

	if (onRegistrationSuccess) {
		return <AuthLogin login={onRegistrationSuccess.login} pass={onRegistrationSuccess.pass} />;
	}

	switch (state) {
		case "login":
			content = <AuthLogin />;
			break;
		case "otp":
			content = <AuthTwoFactor />;
			break;
		case "changePassword":
			content = <ForcePasswordChange />;
			break;
		case "reg1":
		case "reg2":
		case "reg3":
		case "reg4":
		case "regOk":
			content = <RegisterView step={state} />;
			break;
		case "forgot":
			content = <ForgotPassword />;
			break;
		default:
			content = <AuthLogin />;
	}

	if (window.location.pathname.indexOf(RESTORE_ROUTE) !== -1) {
		const position = window.location.pathname.indexOf(RESTORE_ROUTE) + RESTORE_ROUTE.length;
		content = <RestorePassword code={window.location.pathname.slice(position)} />;
	}

	if (window.location.pathname.indexOf(INVITE_ROUTE) !== -1) {
		const position = window.location.pathname.indexOf(INVITE_ROUTE) + INVITE_ROUTE.length;
		content = <InvitePage code={window.location.pathname.slice(position)} />;
	}

	return content;
};
